// extracted by mini-css-extract-plugin
export default {"wrap":"gG-z","subtitle":"hG-z","contentWrap":"iG-z","imgWrap":"jG-z","heading":"kG-z","copy":"lG-z"};